<mat-form-field
  [appearance]="appearance"
  [class]="cssClass"
  [class.skill-selector-dashboard]="styleVariant === 'dashboard'"
  [class.skill-selector-jobs]="styleVariant === 'jobs'"
  [attr.data-testid]="testId + '-field'">
  <input
    type="text"
    [placeholder]="placeholder"
    aria-label="skill"
    matInput
    [formControl]="skillControl"
    [matAutocomplete]="autoSkills"
    [errorStateMatcher]="errorStateMatcher"
    (blur)="onBlur()"
    [attr.data-testid]="testId + '-input'" />

  <!-- Dashboard arrow (24x24) -->
  @if (styleVariant === 'dashboard') {
    <div matSuffix class="mat-mdc-select-arrow-wrapper">
      <div class="mat-mdc-select-arrow">
        <svg viewBox="0 0 24 24" width="24px" height="24px" focusable="false" aria-hidden="true"><path d="M7 10l5 5 5-5z"></path></svg>
      </div>
    </div>
  }

  <!-- Jobs arrow (12x12) -->
  @if (styleVariant === 'jobs') {
    <span matSuffix class="dropdown-arrow">
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M6 8.5L2 4.5H10L6 8.5Z" fill="currentColor"/>
      </svg>
    </span>
  }

  <mat-autocomplete
    autoActiveFirstOption
    #autoSkills="matAutocomplete"
    [displayWith]="displaySkillWith"
    (optionSelected)="onSkillSelected($event.option.value)"
    (closed)="onAutocompleteClosed()">
    @for (category of filteredCategories; track category){
    <!-- Category header (clickable to expand) - disabled prevents Material selection, click handler still works -->
    <mat-option [value]="'__CATEGORY__' + category" class="category-header" [disabled]="true" (click)="toggleCategory(category, $event)">
      <div class="d-flex justify-content-between align-items-center w-100">
        <span>{{ getCategoryDisplayName(category) }}</span>
        <span class="badge bg-secondary ms-2">{{ getSkillCountForCategory(category) }}</span>
        <mat-icon class="ms-auto">{{ isCategoryExpanded(category) ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>
    </mat-option>

    <!-- Skills under category (shown only when expanded) -->
    @if (isCategoryExpanded(category)) { @for (skill of getSkillsForCategory(category); track skill.skillKey){
    <mat-option [value]="skill.skillKey" class="skill-option">
      <span class="ms-3">{{ getSkillDisplayName(skill.skillKey) }}</span>
    </mat-option>
    } } }
  </mat-autocomplete>
</mat-form-field>
